module.exports = __webpack_public_path__ + "media/images/countryrect/bv-e60bf600f0266807da1dfbba6b166175.svg";